import React, { useReducer, useState } from "react";
import { Toast } from "react-bootstrap";
import ToastContext from "../toastcontext/ToastContext";

function ToastProvider({ children }) {
  const [toast, setToast] = useState({
    show: false,
    title: "",
    description: "",
  });

  return (
    <div>
      <ToastContext.Provider value={{ setToast }}>
        {children}
      </ToastContext.Provider>
      <div>
        {toast.show ? (
          <Toast
            onClose={() => setToast({})}
            show={toast.show}
            className="animate__animated  animate__fadeInLeft"
            style={{ position: "fixed", top: 70, right: 0, zIndex: 3 }}
          >
            <Toast.Header>
              <strong className="mr-auto text-danger">{toast.title}</strong>
              <small>5 sec ago</small>
            </Toast.Header>
            <Toast.Body>{toast.description}</Toast.Body>
          </Toast>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default ToastProvider;
